import { FormGroup, FormSection, List } from '@ksyos/design-system';
import { TextAreaFormGroup, TextInputFormGroup } from '../../../../processActivityFormGroupFields';

export function ReferFormGroup() {
    return (
        <>
            <TextInputFormGroup
                fieldKey="refer.organization"
                isRequired={true}
                label="Zorginstelling"
            />
            <TextInputFormGroup
                fieldKey="refer.department"
                label="Afdeling"
            />
            <TextInputFormGroup
                fieldKey="refer.specialismName"
                isRequired={true}
                label="Specialist, naam"
            />
            <FormSection
                isBorderless={true}
                title="Aanvraag"
            >
                <TextInputFormGroup
                    fieldKey="refer.subject"
                    isRequired={true}
                    label="Aanvraag voor (onderwerp)"
                />
                <TextAreaFormGroup
                    fieldKey="refer.message"
                    isRequired={true}
                    label="Bericht aan behandelaar"
                />
                <TextAreaFormGroup
                    fieldKey="refer.reason"
                    isRequired={true}
                    label="Reden doorverwijzing"
                />
            </FormSection>

            <FormSection
                isBorderless={true}
                title="Patiënt informatie"
            >
                <FormGroup label="Bijgevoegde informatie">
                    <List
                        size="small"
                        styleType="bullet"
                    >
                        <List.Item>Professionele samenvatting</List.Item>
                        <List.Item>Aanvullende specialistische bevindingen</List.Item>
                        <List.Item>Patiënten vragenlijsten scores</List.Item>
                        <List.Item>Uitslag slaaponderzoek</List.Item>
                        <List.Item>Beleid</List.Item>
                    </List>
                </FormGroup>
            </FormSection>
            <FormSection
                isBorderless={true}
                title="Conclusie"
            >
                <TextAreaFormGroup
                    fieldKey="refer.conclusion"
                    isRequired={true}
                    label="Conclusie onderbouwing"
                />
                <TextAreaFormGroup
                    fieldKey="refer.question"
                    isRequired={true}
                    label="Verwijsvraag"
                />
            </FormSection>
        </>
    );
}
